import { memo } from 'react';
import { Box, Text } from '@chakra-ui/react';

import InputPanelIconComponent from 'components/Icons/InputPanelIcon';
import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from 'pages/BuilderModeV1/constants';

export interface ShowInputPanelButtonProperties {
  isOpen: boolean;
  onClick: () => void;
}

const ShowInputPanelButton = memo(({ isOpen, onClick }: ShowInputPanelButtonProperties) => (
  <Box
    as='button'
    type='button'
    onClick={onClick}
    aria-label={isOpen ? 'Hide input panel' : 'Show input panel'}
    display='inline-flex'
    alignItems='center'
    gap='8px'
    ml={2}
    px='12px'
    py='10px'
    h='40px'
    minH='40px'
    bg={BUILDER_MODE_V1_TOKENS.white}
    border='1px solid'
    borderColor={BUILDER_MODE_V1_TOKENS.border}
    borderRadius={BUILDER_MODE_V1_LAYOUT.actionButtonRadius}
    cursor='pointer'
    _hover={{ bg: BUILDER_MODE_V1_TOKENS.activeBg }}
    _active={{ bg: BUILDER_MODE_V1_TOKENS.activeBg }}
  >
    <InputPanelIconComponent color={isOpen ? '#8B5CF6' : '#121826'} width={18} height={18} />
    <Text
      fontFamily={BUILDER_MODE_V1_LAYOUT.toolbarFontFamily}
      fontSize='14px'
      fontWeight='400'
      color={BUILDER_MODE_V1_TOKENS.textDark}
      lineHeight='normal'
    >
      {isOpen ? 'Hide input panel' : 'Show input panel'}
    </Text>
  </Box>
));

ShowInputPanelButton.displayName = 'ShowInputPanelButton';

export default ShowInputPanelButton;
